export default "__VITE_ASSET__BIiUhS1S__"